// src/components/TermsAgreementModal.tsx
import React, { useState, useRef, useCallback } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import {
  FileText,
  ChevronDown,
  ChevronUp,
  AlertTriangle,
  CheckCircle,
  XCircle,
  ArrowLeft,
  LogOut,
  Lock,
  ShieldCheck,
  ScrollText,
  Info
} from 'lucide-react';

// ============================================================
// SÖZLEŞME İÇERİĞİ
// ============================================================
const TERMS_SECTIONS = [
  {
    id: 1,
    title: 'Fiyat Verileri ve Güncellik Sorumluluğu',
    ref: 'Amazon Katılım Şartları Madde 2-b ve Lisans Bölümü 2-i',
    content: `İş Ortağı, EBH Sistemi tarafından sağlanan ürün verilerini ve fiyatlarını sadece bilgilendirme amaçlı kullanacağını kabul eder. Amazon üzerindeki fiyatlar ve stok durumu anlık olarak değişebildiğinden, EBH Sistemi sadece satın alma işleminin gerçekleştiği an (checkout) Amazon tarafından onaylanan nihai satış tutarını baz alır. Sipariş geçildikten sonra ürüne gelen zam, indirim veya fiyat dalgalanmalarından kaynaklanan farklar komisyon hesaplamasına dahil edilmez. Verilerin güncelliği konusunda Amazon'un "anlık veri" politikası esastır.`,
  },
  {
    id: 2,
    title: 'Teknik Takip ve Özel Bağlantı (Link) Zorunluluğu',
    ref: 'Amazon Komisyon Gelir Tablosu Madde 1-a ve Katılım Şartları Madde 2',
    content: `Komisyon geliri elde edilebilmesi için satın alma işleminin, EBH Sistemi tarafından sağlanan ve İş Ortağı'na özel olarak tanımlanan "Özel Bağlantılar" yani EKLENTİ üzerinden gerçekleşmesi zorunludur. İş Ortağı'nın eklenti dışında, online izleme olmaksızın veya Özel Bağlantı kullanmadan gerçekleştirdiği manuel alımlar Amazon sistemleri tarafından takip edilemediğinden, bu tür işlemler için EBH Sistemi komisyon yansıtma yükümlülüğü taşımaz. Teknik olarak raporlanmayan hiçbir satış "Nitelikli Satın Alma" sayılmaz. Eklenti kurulduktan sonra alımlar gerçekleşirken eklentide online olma sorumluluğu müşteriye aittir.`,
  },
  {
    id: 3,
    title: 'Teslimat Esaslı Ödeme Döngüsü ve Hak Ediş Takvimi',
    ref: 'Amazon Komisyon Gelir Tablosu Madde 1-a-iii ve Madde 6',
    subsections: [
      {
        id: '3.1',
        title: 'Teslimat Şartı',
        content: `Komisyon hesaplamasında ürünün sipariş edildiği veya ödemesinin yapıldığı tarih değil, ürünün Amazon tarafından kargolanıp müşteriye fiilen ulaştığı "Teslimat Tarihi" esas alınır. Bir siparişin ilgili ayın kazanç raporuna dahil edilebilmesi için, o ayın son gününe kadar (saat 23:59'a kadar) teslimatının tamamlanmış ve Amazon tarafından onaylanmış olması gerekir. Teslimatı gerçekleşmeyen, kargoda bekleyen veya "hazırlanıyor" aşamasındaki ürünler, teslim edildikleri bir sonraki ayın raporuna kaydırılır.`,
      },
      {
        id: '3.2',
        title: 'Ödeme Döngüsü',
        content: `Amazon'un global ödeme politikası (kazancın kesinleşmesini takip eden 60 günlük bekleme süresi) nedeniyle, EBH Sistemi ödemeleri teslimat ayını takip eden 2. ayın sonunda gerçekleştirir. Toplam süreç, teslimat ayından itibaren yaklaşık 90 günlük bir onay ve transfer periyodunu kapsar.`,
      },
      {
        id: '3.3',
        title: 'Uygulama Örnekleri',
        content: `Örnek A (Aynı Ay İçinde Teslimat): 11 Ocak 2026 tarihinde sipariş verilen ve 25 Ocak 2026 tarihinde teslim edilen bir ürün; Ocak ayı sonu raporuna dahil edilir. Ödeme 1-5 Nisan tarihleri arasında transfer edilir.\n\nÖrnek B (Sonraki Aya Sarkan Teslimat): 28 Ocak 2026 tarihinde sipariş verilen ancak 2 Şubat 2026 tarihinde teslim edilen bir ürün; Şubat ayı raporuna dahil edilir. Ödeme 1-5 Mayıs tarihleri arasında yapılır.`,
      },
    ],
  },
  {
    id: 4,
    title: 'İptal, İade ve Komisyon Mahsuplaşma Şartları',
    ref: 'Amazon Komisyon Gelir Tablosu Madde 2-b ve Katılım Şartları Madde 3-d',
    subsections: [
      {
        id: '4.1',
        title: 'Kesinleşmeyen Kazançlar',
        content: `Amazon tarafından herhangi bir aşamada iptal edilen, iade edilen veya geri ödemesi (refund) yapılan hiçbir sipariş için İş Ortağına komisyon ödenmez. Bir siparişin ödeme takvimine girebilmesi için "Nitelikli Satın Alma" statüsünü koruması ve iade edilmemiş olması şarttır.`,
      },
      {
        id: '4.2',
        title: 'İade Durumunda Mahsuplaşma (Geri Alım)',
        content: `Bir ürünün komisyonu EBH sistemine ödendikten sonra dahi, son kullanıcı ürünü iade ederse Amazon bu komisyonu EBH sisteminden geri tahsil eder. Eğer komisyon İş Ortağına henüz ödenmemişse, tutar hak ediş tablosundan silinir. Eğer komisyon İş Ortağına ödenmişse, EBH Sistemi bu tutarı bir sonraki ay oluşacak ilk hak edişinden herhangi bir ihbara gerek kalmaksızın mahsup etme hakkına sahiptir.`,
      },
      {
        id: '4.3',
        title: 'Geçersiz Satın Alımlar ve Hediye Kartı İstisnası',
        content: `Amazon'un "Geçersiz Satın Alma" (hileli trafik, manipülasyon vb.) olarak işaretlediği siparişler için ödeme yapılmaz. Hediye Kartı (Gift Card) veya promosyon bakiyesi kullanılarak tamamlanan satın alma işlemlerinde komisyon oranı sıfır (0) olarak yansır.`,
      },
    ],
  },
  {
    id: 5,
    title: 'Mücbir Sebep, Hesap Kısıtlamaları ve Ödeme Garantisi Reddi',
    ref: 'Amazon Ortaklık Programı İşletme Sözleşmesi Genel Şartları',
    subsections: [
      {
        id: '5.1',
        title: 'Amazon Kaynaklı Kesintiler',
        content: `EBH Sistemi, Amazon ile İş Ortağı arasında bir köprü yazılım hizmetidir. Amazon'un herhangi bir nedenle ödemeleri durdurması, geciktirmesi veya EBH Sistemi ana hesabını kapatması durumunda EBH Sistemi sorumlu tutulamaz.`,
      },
      {
        id: '5.2',
        title: 'Ödeme Şartı',
        content: `İş Ortağı'na yapılacak tüm ödemeler, Amazon'un ilgili tutarı EBH Sistemi hesabına fiilen yatırması şartına bağlıdır. Amazon tarafından bloke edilen kazançlar üzerinde İş Ortağı herhangi bir hak iddia edemez.`,
      },
      {
        id: '5.3',
        title: 'Sistemsel Risklerin Kabulü',
        content: `İş Ortağı, Amazon Associates programının kurallarının Amazon tarafından tek taraflı değiştirilebileceğini ve bu risklerin işin doğasında olduğunu kabul eder.`,
      },
    ],
  },
  {
    id: 6,
    title: 'İçerik Sorumluluğu ve "Olduğu Gibi" Esası',
    ref: 'Amazon Lisans Gereksinimleri Madde 2-k ve Madde 6-t',
    subsections: [
      {
        id: '6.1',
        title: 'İçerik Sağlama',
        content: `EBH Sistemi üzerinden sunulan ürün görselleri, açıklamaları, fiyatlar ve diğer bilgileri Amazon aracılığıyla otomatik olarak çekilmektedir. Bu veriler "olduğu gibi" (as is) sunulur.`,
      },
      {
        id: '6.2',
        title: 'Değişiklik Yasağı',
        content: `İş Ortağı, Amazon'dan gelen içerikleri yanıltıcı olacak şekilde değiştiremez, ürünleri veya Amazon markasını karalayacak şekilde kullanamaz.`,
      },
      {
        id: '6.3',
        title: 'Teknik Sorumluluk Reddi',
        content: `Verilerin Amazon kaynaklı olarak hatalı gelmesi, fiyat bilgilerinin yanlış olması veya Amazon'un ilgili içeriği yayından kaldırması durumunda EBH Sistemi hiçbir sorumluluk kabul etmez.`,
      },
    ],
  },
  {
    id: 7,
    title: 'Bilgi Doğruluğu ve İletişim Zorunluluğu',
    ref: null,
    content: `İş Ortağı, EBH Sistemi'ne kayıt olurken verdiği tüm bilgilerin (Ad, Soyad, IBAN vb.) doğruluğundan bizzat sorumludur. Sistem üzerinde aktif ve ulaşılabilir bir Telefon Numarası girilmesi zorunludur. Yanlış veya eksik iletişim/banka bilgileri nedeniyle yaşanacak ödeme gecikmelerinde veya bildirim aksaklıklarında sorumluluk tamamen müşteriye aittir.`,
  },
  {
    // Ekim 2026 güncellemesiyle eklendi (sözleşme sürümü 1.0 olarak kaldı: 1.0 onaylayanlar onaylı sayılır).
    id: 8,
    title: 'Affiliate Faaliyeti Yürütenlere Hizmet Verilmemesi',
    ref: null,
    subsections: [
      {
        id: '8.1',
        title: 'Hizmet Kapsamı Dışındaki Kişiler',
        content: `EBH Sistemi; Amazon Associates başta olmak üzere herhangi bir affiliate (satış ortaklığı) programı kapsamında üçüncü kişilere affiliate hizmeti veren, bu hizmete aracılık eden veya affiliate faaliyetini kendi adına bireysel olarak yürüten gerçek ve tüzel kişilere hizmet vermez.`,
      },
      {
        id: '8.2',
        title: 'İş Ortağı Beyanı',
        content: `İş Ortağı, EBH Sistemi'ne kayıt olarak ve sistemi kullanmaya devam ederek 8.1 maddesinde belirtilen faaliyetlerden hiçbirini yürütmediğini beyan ve taahhüt eder. Bu faaliyetlerden herhangi birine ileride başlaması hâlinde durumu EBH Sistemi'ne derhal bildirmekle yükümlüdür.`,
      },
      {
        id: '8.3',
        title: 'Aykırılık Hâli',
        content: `İş Ortağı'nın 8.1 maddesi kapsamında faaliyet yürüttüğünün tespit edilmesi hâlinde EBH Sistemi, İş Ortağı'nın hesabını önceden bildirimde bulunmaksızın askıya alma veya kapatma hakkını saklı tutar.`,
      },
    ],
  },
];

// ============================================================
// PROPS
// ============================================================
interface TermsAgreementModalProps {
  isNewUser?: boolean;
  onAccept: () => void;
  onDecline: () => void;
  isAccepting?: boolean;
}

// ============================================================
// DECLINE WARNING MODAL
// ============================================================
interface DeclineWarningModalProps {
  onGoBack: () => void;
  onConfirmDecline: () => void;
  isDeclining?: boolean;
}

export function DeclineWarningModal({ onGoBack, onConfirmDecline, isDeclining }: DeclineWarningModalProps) {
  return (
    <AnimatePresence>
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        className="fixed inset-0 z-[10000] flex items-center justify-center p-4"
        style={{ backgroundColor: 'rgba(0,0,0,0.8)', backdropFilter: 'blur(10px)' }}
      >
        <motion.div
          initial={{ opacity: 0, y: 30, scale: 0.97 }}
          animate={{ opacity: 1, y: 0, scale: 1 }}
          transition={{ type: 'spring', damping: 25, stiffness: 300 }}
          className="bg-white rounded-2xl w-full max-w-md overflow-hidden shadow-2xl"
        >
          {/* Red Header */}
          <div className="bg-gradient-to-br from-red-600 to-red-800 px-7 py-7 text-center">
            <div className="w-14 h-14 rounded-full bg-white/15 flex items-center justify-center mx-auto mb-4">
              <AlertTriangle className="w-7 h-7 text-white" />
            </div>
            <h2 className="text-xl font-bold text-white">Hesabınız Pasif Hale Gelecek!</h2>
          </div>

          <div className="px-7 py-6">
            <p className="text-sm text-gray-700 mb-4">
              Kullanıcı sözleşmesini kabul etmemeniz durumunda:
            </p>

            <div className="space-y-2.5 mb-5">
              {[
                'Hesabınız otomatik olarak pasif duruma geçecektir',
                'Kontrol paneline, siparişlerinize ve kazanç bilgilerinize erişiminiz engellenecektir',
                'Eklenti üzerinden yapılan satın alımlar komisyon kazandırmayacaktır',
                'Hesabınızı yeniden aktifleştirmek için sözleşmeyi onaylamanız gerekecektir',
              ].map((text, i) => (
                <div key={i} className="flex items-start gap-2.5 bg-red-50 border border-red-200 rounded-lg px-3.5 py-2.5">
                  <XCircle className="w-4 h-4 text-red-500 mt-0.5 flex-shrink-0" />
                  <span className="text-xs text-red-800 leading-relaxed">{text}</span>
                </div>
              ))}
            </div>

            <div className="bg-amber-50 border border-amber-200 rounded-lg px-3.5 py-3 mb-5">
              <div className="flex items-start gap-2">
                <Info className="w-4 h-4 text-amber-600 mt-0.5 flex-shrink-0" />
                <p className="text-xs text-amber-800 leading-relaxed">
                  <strong>Not:</strong> Sözleşmeyi daha sonra onaylayarak hesabınızı tekrar aktifleştirebilirsiniz.
                  Ancak pasif dönemde oluşan satışlardan komisyon hak edişi doğmaz.
                </p>
              </div>
            </div>

            <div className="flex gap-3">
              <button
                onClick={onGoBack}
                className="flex-1 flex items-center justify-center gap-2 bg-gradient-to-r from-amber-500 to-red-500 text-white font-bold py-3 px-5 rounded-xl hover:shadow-lg transition-all text-sm"
              >
                <ArrowLeft className="w-4 h-4" />
                Geri Dön ve Onayla
              </button>
              <button
                onClick={onConfirmDecline}
                disabled={isDeclining}
                className="flex items-center justify-center gap-2 border border-red-200 text-red-600 font-semibold py-3 px-5 rounded-xl hover:bg-red-50 transition-all text-sm disabled:opacity-50"
              >
                {isDeclining ? (
                  <div className="w-4 h-4 border-2 border-red-400 border-t-transparent rounded-full animate-spin" />
                ) : (
                  'Reddet'
                )}
              </button>
            </div>
          </div>
        </motion.div>
      </motion.div>
    </AnimatePresence>
  );
}

// ============================================================
// MAIN TERMS MODAL
// ============================================================
export default function TermsAgreementModal({
  isNewUser = false,
  onAccept,
  onDecline,
  isAccepting = false,
}: TermsAgreementModalProps) {
  const [scrolledToBottom, setScrolledToBottom] = useState(false);
  const [accepted, setAccepted] = useState(false);
  const [expandedSections, setExpandedSections] = useState<Set<number>>(new Set());
  const scrollRef = useRef<HTMLDivElement>(null);

  const handleScroll = useCallback((e: React.UIEvent<HTMLDivElement>) => {
    const { scrollTop, scrollHeight, clientHeight } = e.currentTarget;
    if (scrollHeight - scrollTop - clientHeight < 60) {
      setScrolledToBottom(true);
    }
  }, []);

  const toggleSection = (id: number) => {
    const next = new Set(expandedSections);
    if (next.has(id)) next.delete(id);
    else next.add(id);
    setExpandedSections(next);
  };

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      className="fixed inset-0 z-[9999] flex items-center justify-center p-4"
      style={{ backgroundColor: 'rgba(0,0,0,0.7)', backdropFilter: 'blur(8px)' }}
    >
      <motion.div
        initial={{ opacity: 0, y: 30, scale: 0.97 }}
        animate={{ opacity: 1, y: 0, scale: 1 }}
        transition={{ type: 'spring', damping: 25, stiffness: 300 }}
        className="bg-white rounded-2xl w-full max-w-2xl flex flex-col shadow-2xl"
        style={{ maxHeight: '90vh' }}
      >
        {/* Header */}
        <div className="bg-gradient-to-br from-gray-900 to-gray-800 px-8 py-6 rounded-t-2xl border-b-[3px] border-amber-500">
          <div className="flex items-center gap-3.5 mb-2">
            <div className="w-11 h-11 rounded-xl bg-gradient-to-br from-amber-500 to-red-500 flex items-center justify-center shadow-lg">
              <ScrollText className="w-5 h-5 text-white" />
            </div>
            <div>
              <h1 className="text-xl font-bold text-white tracking-tight">İş Ortaklığı Sözleşmesi</h1>
              <p className="text-xs text-gray-400 mt-0.5">EarnBackHub Kullanıcı Hizmet Sözleşmesi</p>
            </div>
          </div>

          {isNewUser ? (
            <div className="bg-blue-500/10 border border-blue-500/20 rounded-lg px-3.5 py-2.5 mt-3 flex items-center gap-2.5">
              <span className="text-base">🎉</span>
              <p className="text-xs text-blue-300 leading-relaxed">
                Hoş geldiniz! Sistemi kullanmaya başlamadan önce lütfen aşağıdaki sözleşmeyi okuyup onaylayınız.
              </p>
            </div>
          ) : (
            <div className="bg-amber-500/10 border border-amber-500/20 rounded-lg px-3.5 py-2.5 mt-3 flex items-center gap-2.5">
              <FileText className="w-4 h-4 text-amber-400 flex-shrink-0" />
              <p className="text-xs text-amber-300 leading-relaxed">
                Güncellenen kullanıcı sözleşmemizi onaylamadan sisteme devam edemezsiniz. Lütfen dikkatlice okuyunuz.
              </p>
            </div>
          )}
        </div>

        {/* Scrollable Content */}
        <div
          ref={scrollRef}
          onScroll={handleScroll}
          className="flex-1 overflow-y-auto px-8 py-5 bg-gray-50"
        >
          {/* Intro */}
          <div className="bg-white border border-gray-200 rounded-xl px-5 py-4 mb-5">
            <p className="text-sm text-gray-600 leading-relaxed">
              Bu sözleşme, <strong className="text-gray-800">EarnBackHub ("EBH Sistemi")</strong> ile İş Ortağı ("Kullanıcı") arasındaki
              hak ve yükümlülükleri düzenler. Sistemi kullanmaya devam etmeniz, aşağıdaki tüm maddeleri okuduğunuz ve kabul ettiğiniz anlamına gelir.
            </p>
          </div>

          {/* Sections */}
          {TERMS_SECTIONS.map((section) => (
            <div
              key={section.id}
              className="bg-white border border-gray-200 rounded-xl mb-3 overflow-hidden transition-shadow hover:shadow-sm"
            >
              <button
                onClick={() => toggleSection(section.id)}
                className="w-full flex items-center justify-between px-5 py-4 text-left hover:bg-gray-50 transition-colors"
              >
                <div className="flex items-center gap-3 flex-1">
                  <div
                    className={`w-8 h-8 rounded-lg flex items-center justify-center text-xs font-bold transition-all flex-shrink-0 ${
                      expandedSections.has(section.id)
                        ? 'bg-gradient-to-br from-amber-500 to-red-500 text-white'
                        : 'bg-gray-100 text-gray-500'
                    }`}
                  >
                    {section.id}
                  </div>
                  <div>
                    <p className="font-semibold text-sm text-gray-800">{section.title}</p>
                    {section.ref && (
                      <p className="text-[11px] text-gray-400 mt-0.5">Ref: {section.ref}</p>
                    )}
                  </div>
                </div>
                {expandedSections.has(section.id) ? (
                  <ChevronUp className="w-4 h-4 text-gray-400" />
                ) : (
                  <ChevronDown className="w-4 h-4 text-gray-400" />
                )}
              </button>

              <AnimatePresence>
                {expandedSections.has(section.id) && (
                  <motion.div
                    initial={{ height: 0, opacity: 0 }}
                    animate={{ height: 'auto', opacity: 1 }}
                    exit={{ height: 0, opacity: 0 }}
                    transition={{ duration: 0.2 }}
                    className="overflow-hidden"
                  >
                    <div className="px-5 pb-5 border-t border-gray-100">
                      {section.content && (
                        <p className="text-sm text-gray-600 leading-relaxed mt-4 whitespace-pre-line">
                          {section.content}
                        </p>
                      )}
                      {section.subsections && section.subsections.map((sub) => (
                        <div key={sub.id} className="mt-4">
                          <div className="flex items-center gap-2 mb-2">
                            <span className="text-[11px] font-bold text-amber-600 bg-amber-50 px-2 py-0.5 rounded">
                              {sub.id}
                            </span>
                            <span className="text-sm font-semibold text-gray-700">{sub.title}</span>
                          </div>
                          <p className="text-sm text-gray-600 leading-relaxed pl-2 border-l-2 border-gray-100 whitespace-pre-line">
                            {sub.content}
                          </p>
                        </div>
                      ))}
                    </div>
                  </motion.div>
                )}
              </AnimatePresence>
            </div>
          ))}

          {/* Scroll Hint */}
          {!scrolledToBottom && (
            <div className="text-center py-3 animate-pulse">
              <span className="text-xs text-gray-400">↓ Sözleşmenin tamamını okumak için aşağı kaydırın</span>
            </div>
          )}
        </div>

        {/* Footer */}
        <div className="px-8 py-5 border-t border-gray-200 bg-white rounded-b-2xl">
          {/* Checkbox */}
          <label
            className={`flex items-start gap-3 mb-4 transition-opacity ${
              scrolledToBottom ? 'opacity-100 cursor-pointer' : 'opacity-40 cursor-not-allowed'
            }`}
          >
            <input
              type="checkbox"
              checked={accepted}
              onChange={(e) => scrolledToBottom && setAccepted(e.target.checked)}
              disabled={!scrolledToBottom}
              className="w-5 h-5 mt-0.5 accent-amber-500 flex-shrink-0"
            />
            <span className="text-sm text-gray-700 leading-relaxed">
              Yukarıdaki <strong>İş Ortaklığı Sözleşmesi</strong>'nin tüm maddelerini okudum, anladım ve kabul ediyorum.
              Bu sözleşme şartlarına uyacağımı taahhüt ederim.
            </span>
          </label>

          {!scrolledToBottom && (
            <div className="bg-amber-50 border border-amber-200 rounded-lg px-3.5 py-2 mb-3.5">
              <p className="text-[11px] text-amber-700 flex items-center gap-1.5">
                <Info className="w-3.5 h-3.5 flex-shrink-0" />
                Onay kutusunu işaretleyebilmek için sözleşmenin tamamını okumanız gerekmektedir.
              </p>
            </div>
          )}

          {/* Buttons */}
          <div className="flex gap-3 justify-end">
            <button
              onClick={onDecline}
              className="px-6 py-3 text-sm font-semibold text-gray-500 border border-gray-200 rounded-xl hover:bg-gray-50 transition-all"
            >
              Kabul Etmiyorum
            </button>
            <button
              onClick={onAccept}
              disabled={!accepted || isAccepting}
              className={`flex items-center gap-2 px-7 py-3 text-sm font-bold rounded-xl transition-all ${
                accepted && !isAccepting
                  ? 'bg-gradient-to-r from-amber-500 to-red-500 text-white shadow-lg hover:shadow-xl'
                  : 'bg-gray-200 text-gray-400 cursor-not-allowed'
              }`}
            >
              {isAccepting ? (
                <>
                  <div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin" />
                  Onaylanıyor...
                </>
              ) : (
                <>
                  <ShieldCheck className="w-4 h-4" />
                  Sözleşmeyi Onaylıyorum
                </>
              )}
            </button>
          </div>

          <p className="text-[11px] text-gray-400 text-center mt-3.5">
            Sözleşmeyi onaylayarak, bu sözleşmenin tüm maddelerini kabul etmiş olursunuz.
          </p>
        </div>
      </motion.div>
    </motion.div>
  );
}